<template>
    <v-row>
        <v-col cols="12" md="12">
            <h5 class="pb-3">{{keyForTranslate}}</h5>
            <v-color-picker v-model="color" flat hide-inputs></v-color-picker>
        </v-col>
    </v-row>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      color: ''
    }
  },
  computed: {
    keyForTranslate() {
      let val = ''
      let loc = this.label.split('$')
      if (loc.length == 1) {
        val = loc[0]
      } else {
        val = loc[1]
      }
      return this.$t(val)
    }
  },
  mounted() {
    this.syncColorWithValue()
  },
  methods: {
    syncColorWithValue() {
      if (this.value === '' || this.value == undefined || this.value == null) {
        this.color = ''
      } else {
        this.color = this.value
      }
    }
  },
  watch: {
    color: {
      handler() {
        let color = null
        if (
          this.color !== '' ||
          this.color != undefined ||
          this.color != null
        ) {
          color = this.color.substring(0, 7)
        }
        this.$emit('input', color)
      }
    },
    value: {
      handler() {
        this.syncColorWithValue()
      }
    }
  }
}
</script>

<style>
</style>
